<template>
  <div class="Subpage">
    <Bigmenu
      :NavStatus="Bignav"
      :Way="5"
      :ShowBackBtn="true"
      v-on:cellback="OpenStatus"
      style="z-index: 2"
    ></Bigmenu>
    <div class="frame" style="z-index: -1"></div>
    <Submenu
      v-if="!Bignav"
      :Info="SubInfo"
      :DividNum="4"
      :BGImgUrl="'sbg0106.png'"
      :Submenu="Submenu"
      v-on:cellback="Navgo"
      style="z-index: -6"
    ></Submenu>
    <router-view />
  </div>
</template>

<script>
import Bigmenu from "@/components/Bigmenu.vue";
import Back from "@/components/Back.vue";
import Submenu from "@/components/Submenu.vue";
export default {
  name: "About",
  data() {
    return {
      Bignav: false,
      SubInfo: {
        title: "質子治療",
        body: ""
      },
      Submenu: [
        {
          id: "01",
          subtitle: "What is proton therapy?",
          text: "何謂質子治療"
        },
        {
          id: "02",
          subtitle: "ProBeam<sup>®</sup> 360°System",
          text: "ProBeam<sup>®</sup> 360° 質子治療系統"
        },
        {
          id: "03",
          subtitle: "PBS (Pencil Beam Scanning) Technology",
          text: "筆尖射束技術介紹"
        },
        {
          id: "04",
          subtitle: "FLASH Radiotherapy",
          text: "FLASH質子閃射療法"
        }
      ]
    };
  },
  components: {
    Back,
    Submenu,
    Bigmenu
  },
  methods: {
    Navgo(v) {
      switch (v) {
        case 0:
          this.$router.push("/P01");
          break;
        case 1:
          this.$router.push("/P02");
          break;
        case 2:
          this.$router.push("/P03");
          break;
        case 3:
          this.$router.push("/P05");
          break;
      }
    },
    OpenStatus(v) {
      this.Bignav = v.status;
    }
  }
};
</script>
<style lang="scss" scoped>
.Subpage {
  height: 100%;
  width: 100%;
}
.frame {
  position: absolute;
  background-image: url("../assets/frame.png");
  background-position: center;
  height: 1080px;
  width: 1920px;
}
</style>
